import {
  CampaignTypesKey,
  GlobalListPageKey,
  GlobalPageHeaderKey,
  TableTypesKey,
  TextEditorKey,
  UtilsTypesKey
} from 'utils/globalTranslation/TModules';

export const translations = {
  [GlobalListPageKey]: {
    RequestHasBeenApproved: 'Anfrage wurde genehmigt',
    RequestHasBeenDeleted: 'Anfrage wurde gelöscht',
    RequestHasBeenDenied: 'Anfrage wurde abgelehnt',
    RequestHasBeenCancelled: 'Anfrage wurde storniert',
    RequestsHaveBeenApproved: 'Anfragen wurden genehmigt',
    ThisFieldIsRequired: 'Dieses Feld ist erforderlich',
    SomethingWentWrong: 'Etwas ist schiefgelaufen',
    Edit: 'Bearbeiten',
    Maker: 'Ersteller',
    Checker: 'Prüfer',
    Cancel: 'Abbrechen',
    Confirm: 'Bestätigen',
    NoData: 'Keine Daten',
    Day: 'Tag',
    Week: 'Woche',
    Month: 'Monat',
    Year: 'Jahr',
    Days: 'tage',
    Weeks: 'wochen',
    Months: 'monate',
    Required: 'Pflichtfeld',
    MinValue: 'Muss ein positiver Wert und mindestens {{min}} sein',
    MaxValue: 'Darf nicht größer als {{max}} sein',
    MustBeInteger: 'Muss eine Ganzzahl sein',
    MustBeNumber: 'Muss eine Zahl sein',
    InvalidEmail: 'Ungültige E-Mail-Adresse',
    InvalidUrl: 'Ungültige URL',
    NotGreaterThanUserLimit: 'Der Wert darf das Benutzerlimit nicht überschreiten',
    NotGreaterThanRewardLimit: 'Der Wert darf das Belohnungslimit nicht überschreiten',
    ValueMustBePositive: 'Der Wert muss positiv sein',
    ValueMustBeMoreThanZero: 'Der Wert muss größer als null sein',
    InvalidCsvXlsx:
      'Es sind nur .xlsx/.csv-Dateien zulässig; der hochgeladene Dateityp ist ungültig.',
    OnlyImageTypes: 'Sie können nur JPG/JPEG/PNG/SVG-Dateien hochladen!',
    SvgUnprocessable: 'SVG-Datei ist nicht verarbeitbar!'
  },
  [GlobalPageHeaderKey]: {
    RewardRequest: 'Belohnungsanfrage'
  },
  [CampaignTypesKey]: {
    AllCampaigns: 'Alle Kampagnen',
    InstantReward: 'Sofortige Belohnung',
    Stamp: 'Stempel',
    Game: 'Spiel',
    Quiz: 'Quiz',
    Survey: 'Umfrage',
    Quest: 'Aufgabe',
    Progress: 'Fortschritt',
    Raffle: 'Verlosung',
    Streak: 'Serie',
    AllGames: 'Alle Spiele',
    SpinTheWheel: 'Dreh Das Rad',
    ShakeTheTree: 'Schüttle Den Baum',
    HitThePinata: 'Schlag Die Piñata',
    ScratchCard: 'Rubbelkarte',
    Plinko: 'Plinko',
    BubblePop: 'Blasen-Pop',
    ClawMachine: 'Greifautomat',
    Reward: 'Belohnung',
    Referral: 'Empfehlung',
    TeamProgress: 'Teamfortschritt',
    MultipleRuleCampaign: 'Kampagne Mit Mehreren Regeln',
    Generic: 'Allgemein',
    RuleTriggerDays: 'Regelauslösetage',
    TriggerDays: 'Auslösetage',
    TriggerOnSpecificDays: 'An bestimmten Tagen auslösen',
    HoverMe: 'Zeig auf mich',
    From: 'Von',
    To: 'Bis',
    SelectDays: 'Tage auswählen',
    SelectTime: 'Zeit auswählen',
    Campaign: 'Kampagne',
    Points: 'Punkte',
    Cashback: 'Cashback',
    Voucher: 'Gutschein',
    Batch: 'Stapel',
    PrizeSet: 'Preisset',
    LoyaltyCurrency: 'Treuewährung',
    Rewards: 'Belohnungen',
    Audience: 'Zielgruppe',
    UpdateCustomerDetails: 'Kundendaten aktualisieren',
    PushEventOnly: 'Nur Ereignis senden'
  },
  [UtilsTypesKey]: {
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',
    January: 'Januar',
    February: 'Februar',
    March: 'März',
    April: 'April',
    May: 'Mai',
    June: 'Juni',
    July: 'Juli',
    August: 'August',
    September: 'September',
    October: 'Oktober',
    November: 'November',
    December: 'Dezember'
  },
  [TableTypesKey]: {
    PerPage: '/ Seite',
    GoTo: 'Gehe zu',
    Page: 'Seite',
    PreviousPage: 'Vorherige Seite',
    NextPage: 'Nächste Seite',
    NoData: 'Keine Daten'
  },
  [TextEditorKey]: {
    ButtonTooltip: 'Schaltfläche',
    ButtonDialogTitle: 'Schaltfläche einfügen',
    Url: 'URL',
    Text: 'Text',
    BackgroundColor: 'Hintergrundfarbe',
    TextColor: 'Textfarbe',
    PaddingVertical: 'Vertikaler Innenabstand',
    PaddingHorizontal: 'Horizontaler Innenabstand',
    CornerStyle: 'Eckenform',
    CornerSquare: 'Eckig',
    CornerRounded: 'Abgerundet',
    CornerPill: 'Pillenform',
    BorderRadius: 'Eckenradius',
    Insert: 'Einfügen',
    Unlink: 'Verknüpfung entfernen',
    Remove: 'Entfernen'
  }
};
